import React from 'react';
import { ISVGType } from './SVGType';

const SuccessToastIcon = (props: ISVGType) => {
  const { width = 62, height = 62, color = "#3BD378" } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.2" cx="31" cy="31" r="13" fill="#14B2A9" />
      <circle opacity="0.2" cx="31.0009" cy="31" r="10.9032" fill="#14B2A9" />
      <circle opacity="0.2" cx="30.9992" cy="31" r="9.22581" fill="#14B2A9" />
      <g filter="url(#filter0_d_484_370)">
        <circle cx="31" cy="31" r="18" fill={color} />
      </g>
      <g filter="url(#filter1_d_484_370)">
        <path
          d="M24.0009 32.1964L27.7144 35.9114L37.002 26.6276"
          stroke="white"
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_484_370"
          x="9"
          y="9"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset/>
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0642389 0 0 0 0 0.621667 0 0 0 0 0.589914 0 0 0 0.5 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_484_370" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_484_370" result="shape" />
        </filter>
        <filter
          id="filter1_d_484_370"
          x="22.25"
          y="24.8776"
          width="16.502"
          height="14.7839"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_484_370" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_484_370" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default SuccessToastIcon;
